import { RoleProtected } from '../Components/RoleProtected';
import RecordDataView from '../Components/RecordDataPageComp/Views/RecordDataView';

export default function RecordDataPage() {
  return (
    <RoleProtected allowedRoles={["user", "Admin"]} showPageAction="record_data_view">
      <RecordDataView />
    </RoleProtected>
  );
}